import { render, staticRenderFns } from "./select-tree.vue?vue&type=template&id=1dce1332&scoped=true"
import script from "./select-tree.vue?vue&type=script&lang=js"
export * from "./select-tree.vue?vue&type=script&lang=js"
import style0 from "./select-tree.vue?vue&type=style&index=0&id=1dce1332&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dce1332",
  null
  
)

export default component.exports